import Column from '@components/Column';
import Image from '@components/Image';
import styled from '@emotion/styled';
import { MainRecommendedItemRow } from '@models/item/recommendedItem';
import { Link } from '@stackflow/link';
import { pressActionEffect } from '@styles/mixin';

import RecommendationText from './RecommendationText';

interface Props {
    item: MainRecommendedItemRow;
}

function RecommendationItem({ item }:Props) {
    const { thumbnailUrl } = item;
    return (
        <Link activityName='ShopListActivity'
            activityParams={{
                originalItemId: item.itemId,
                type: 'LIST',
                isOrder: true,
            }}
            css={pressActionEffect}>
            <Container spacing={2} fullWidth>
                <ThumbnailImage src={thumbnailUrl}
                    width={120}
                    height={120}
                    alt='음료' />
                <RecommendationText item={item} />
            </Container>
        </Link>
    );
}

const ThumbnailImage = styled(Image)`
    aspect-ratio: 1;
    border-radius: var(--radius-xs);
    overflow: hidden;
    object-fit: cover;
    width: 100%;
`;

const Container = styled(Column)`
    max-width: 120px;
    min-width: 120px;
`;

export default RecommendationItem;
